import './App.css';
import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Header, Main } from './layouts';
import { authService } from './api';

export default function App() {
  const [auth, setAuth] = useState(localStorage.getItem('token'));
  let history = useHistory();

  const logoutFunction = useCallback(() => {
    authService().logout();
    setAuth(localStorage.getItem('token'));
    history.push('/logout');
  }, [history]);

  //returning user with an expired token must log back in
  if ((Date.parse(Date()) - (localStorage.getItem('timeout'))) > 0) {
    authService().logout();
  }

  return (
    <>
      <Header auth={auth} logout={logoutFunction}/>
      <Main logout={logoutFunction}/>
    </>
  );
};